import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { AutoGlowBrand } from "./components/AutoGlowLogo";
import ThemeSwitch from "./components/ThemeSwitch";
import { CheckCircle, Spinner, Warning, ArrowRight } from "@phosphor-icons/react";

const POLL_INTERVAL = 2000;
const MAX_ATTEMPTS = 6;

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ phase: "checking", message: "Comprobando tu pago..." });

  useEffect(() => {
    if (!sessionId) {
      setState({ phase: "error", message: "Falta session_id" });
      return;
    }
    let cancelled = false;
    let attempts = 0;
    const tick = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/billing/checkout/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setState({ phase: "success", message: "¡Suscripción activada!" });
          return;
        }
        if (data.status === "expired") {
          setState({ phase: "error", message: "La sesión ha expirado. Vuelve a iniciar el checkout." });
          return;
        }
        if (attempts >= MAX_ATTEMPTS) {
          setState({ phase: "pending", message: "Tu pago se está procesando. Te avisaremos por email cuando se confirme." });
          return;
        }
        setTimeout(tick, POLL_INTERVAL);
      } catch (e) {
        if (cancelled) return;
        setState({ phase: "error", message: "Error verificando el pago. Vuelve a intentarlo." });
      }
    };
    tick();
    return () => { cancelled = true; };
  }, [sessionId]);

  const Icon = state.phase === "success" ? CheckCircle : state.phase === "error" ? Warning : Spinner;
  const color = state.phase === "success" ? "text-emerald-400" : state.phase === "error" ? "text-red-400" : "text-[var(--ag-gold)]";

  return (
    <div className="min-h-screen ag-radial flex items-center justify-center p-6">
      <div className="fixed top-4 right-4 z-50"><ThemeSwitch /></div>
      <div className="ag-card p-10 max-w-md w-full text-center">
        <div className="flex justify-center"><AutoGlowBrand size={24} /></div>
        <Icon size={56} weight="duotone" className={`mx-auto mt-6 ${color} ${state.phase === "checking" ? "animate-spin" : ""}`} data-testid="billing-success-icon" />
        <h1 className="font-display font-bold text-2xl mt-6 tracking-tighter">{state.message}</h1>
        {state.phase === "success" && (
          <p className="text-sm text-[var(--ag-text-dim)] mt-3">Tu centro tiene acceso completo durante 30 días. Ya puedes operar sin restricciones.</p>
        )}
        {state.phase === "pending" && (
          <p className="text-sm text-[var(--ag-text-dim)] mt-3">Te enviaremos un email tan pronto como el pago se confirme. Mientras tanto, mantienes acceso de prueba.</p>
        )}
        <Button onClick={()=>navigate(state.phase === "success" ? "/" : "/billing")} className="ag-btn-gold h-11 mt-8 w-full">
          {state.phase === "success" ? "Entrar al panel" : "Volver a facturación"} <ArrowRight className="ml-2" weight="bold" />
        </Button>
      </div>
    </div>
  );
}
